import { unixTimeToHMSString, unixTimeToYMDDashedStr } from '@shared/utils';
import {
  Table,
  TableCell,
  TableHeader,
  TableRow,
} from '@web/components/ui/table';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@web/components/ui/tooltip';
import { TooltipProvider } from '@web/components/ui/tooltip';

import { trpc } from '@web/lib/trpc';

export function ContactPayments({ contactId }: { contactId: string }) {
  const { data: paymentsData } = trpc.payment.listAll.useQuery({
    contactId,
  });

  if (!paymentsData) return null;

  return (
    <div className="space-y-4">
      <Table>
        <TableHeader>
          <TableRow>
            <TableCell className="font-semibold">Amount</TableCell>
            <TableCell className="font-semibold">Date</TableCell>
          </TableRow>
        </TableHeader>

        <TooltipProvider>
          {paymentsData.map((payment) => (
            <TableRow key={payment.paymentId} className="">
              <TableCell>$ {payment.amount}</TableCell>

              {payment.paymentDate && (
                <TableCell>
                  <Tooltip>
                    <TooltipTrigger>
                      {unixTimeToYMDDashedStr(
                        new Date(payment.paymentDate).getTime(),
                      )}
                    </TooltipTrigger>

                    <TooltipContent>
                      {unixTimeToHMSString(
                        new Date(payment.paymentDate).getTime(),
                      )}
                    </TooltipContent>
                  </Tooltip>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TooltipProvider>
      </Table>
    </div>
  );
}
